export default __webpack_public_path__ + "static/media/caid_logos_new.8f6ff262.png";